// MQTT 客户端单例：封装连接/订阅/发布/消息分发/断开/重连 [Claude Code]
import mqtt from 'mqtt'

class MQTTClient {
  constructor () {
    this.client = null
    this.isConnected = false
    this.messageCallbacks = [] // 消息回调数组 [Claude Code]
    this.retryCount = 0
    this.maxRetries = 3 // 最大重连次数 [Claude Code]
    this.retryDelay = 10000 // 重连间隔(ms) [Claude Code]
  }

  // 连接 MQTT 服务器；已连接则直接 resolve，无 url 则 reject [Claude Code]
  connect (options = {}) {
    const {
      url,
      clientId,
      username,
      password,
      clean = true,
      protocolVersion = 5
    } = options

    if (this.isConnected) {
      return Promise.resolve(this.client)
    }
    if (!url) {
      return Promise.reject(new Error('No MQTT URLs provided'))
    }

    this.retryCount = 0
    this.client = mqtt.connect(url, {
      clientId,
      username,
      password,
      clean,
      reconnectPeriod: this.retryDelay,
      protocolVersion
    })
    console.info(4444444, 'mqtt connect with options', { url, clientId, username, clean, protocolVersion })

    this._setupEventListeners()

    return new Promise((resolve, reject) => {
      this.client.once('connect', (connack) => {
        this.isConnected = true
        this.retryCount = 0
        resolve(connack)
      })
      this.client.once('error', (err) => {
        reject(err)
      })
    })
  }

  // 订阅主题 [Claude Code]
  subscribe (topic, options = { qos: 0 }) {
    if (!this.client || !this.isConnected) {
      return Promise.reject(new Error('MQTT client not connected'))
    }
    return new Promise((resolve, reject) => {
      this.client.subscribe(topic, options, (err, granted) => {
        if (err) {
          reject(err)
        } else {
          console.info(4444444, 'subscribe topic', topic)
          resolve(granted)
        }
      })
    })
  }

  // 取消订阅主题；未连接时静默 resolve（断连后无需退订）[Claude Code]
  unsubscribe (topic) {
    if (!this.client || !this.isConnected) {
      return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      this.client.unsubscribe(topic, (err) => {
        if (err) {
          reject(err)
        } else {
          console.info(4444444, 'unsubscribe topic', topic)

          resolve()
        }
      })
    })
  }

  // 发布消息 [Claude Code]
  publish (topic, message, options = { qos: 0, retain: true }) {
    if (!this.client || !this.isConnected) {
      return Promise.reject(new Error('MQTT client not connected'))
    }
    const messageStr = typeof message === 'string' ? message : JSON.stringify(message)
    return new Promise((resolve, reject) => {
      this.client.publish(topic, messageStr, options, (err) => {
        if (err) {
          reject(err)
        } else {
          resolve()
        }
      })
    })
  }

  // 注册消息回调 [Claude Code]
  onMessage (callback) {
    if (typeof callback === 'function') {
      this.messageCallbacks.push(callback)
    }
  }

  // 移除消息回调 [Claude Code]
  offMessage (callback) {
    const index = this.messageCallbacks.indexOf(callback)
    if (index > -1) {
      this.messageCallbacks.splice(index, 1)
    }
  }

  // 断开连接：结束 client + 复位状态 + 清空回调 [Claude Code]
  disconnect () {
    if (this.client) {
      this.client.end()
      console.info(4444444, 'disconnect')
      this.client = null
      this.isConnected = false
      this.messageCallbacks = []
    }
  }

  // 获取连接状态 [Claude Code]
  getConnected () {
    return this.isConnected
  }

  // 注册底层事件监听 [Claude Code]
  _setupEventListeners () {
    if (!this.client) return

    // 消息事件：遍历分发到所有回调，单个回调异常被隔离 [Claude Code]
    this.client.on('message', (topic, message, packet) => {
      const msg = message.toString()
      this.messageCallbacks.forEach(callback => {
        try {
          callback(topic, msg, packet)
        } catch (err) {
          console.error('Message callback error:', err)
        }
      })
    })

    // 重连事件：累加计数，超过上限主动 end 停止重连 [Claude Code]
    this.client.on('reconnect', () => {
      // client 已置空（上次超限已 end）则忽略后续 reconnect 事件，避免 null.end() NPE [Claude Code]
      // mqtt 库在 end() 后仍会再 emit 一次 reconnect，必须守卫 [Claude Code]
      if (!this.client) return
      this.retryCount++
      if (this.retryCount > this.maxRetries) {
        this.client.end()
        this.client = null // 超限停止重连后置空，与 disconnect 保持一致 [Claude Code]
      }
    })
    this.client.on('close', () => { this.isConnected = false })
    this.client.on('error', (err) => console.error('[MQTT] error', err))
    this.client.on('offline', () => { this.isConnected = false })
    this.client.on('end', () => { this.isConnected = false })
  }
}

// 单例：全应用共用一个连接 [Claude Code]
const mqttClient = new MQTTClient()
export default mqttClient
